import React, { useState, useEffect } from "react";
import axios from "axios";
import "./S3upload.scss";
import CLOSE_ICON from "../../Images/closed.png";
import { Typography } from "@mui/material";
import { Grid, Stack, Box } from "@mui/material";
import AWS from "aws-sdk";
import Upload from "../../Images/Icon_Upload.svg";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Button from "../common/Button";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API } from "../../globals/constants";
import InputField from "../common/InputField";
import { ToastContainer, toast } from "react-toastify";

const S3upload = (props) => {
  const { closeModal, CancelledTraining, createdBy } = props;
  const [cancelReason, setCancelReason] = useState();
  const [progress, setProgress] = useState(0);
  const [projectLink, setProjectLink] = useState("");
  const [projectName, setProjectName] = useState("");
  const [flag, setFlag] = useState(true);
  const [selectedFile, setSelectedFile] = useState();
  const [tempUrl, setTempUrl] = useState();
  const [continueButton, setContinueButton] = useState(false);

  useEffect(() => {
    handlePushToS3(tempUrl, selectedFile);
  }, [tempUrl]);

  const handleButtonClick = () => {
    let pattern = /^[a-zA-Z0-9\-]+(?:\.zip|\.rar|\.7z)$/;
    let containsSpace = projectName.includes(" ");

    if (projectName === "") {
      toast.error(`Please add project name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else if (containsSpace) {
      toast.error(`Project name should not contain spaces `, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else if (!pattern.test(projectName)) {
      toast.error(
        `Please add a valid Project name extension (.zip, .rar, .7z)`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        }
      );
    } else {
      let fileInput = document.getElementById("file-upload");
      fileInput.click();

      fileInput.addEventListener("change", (event) => {
        // Handle the file selection by the user
        const selectedFile = event.target.files[0];
        console.log("Selected file:", selectedFile);
        let fileName = fileInput.files[0].name;
        let fileExtension = fileName.split(".").pop();
        let projectNameWithExtension = projectName + "." + fileExtension;
        // setProjectName(projectNameWithExtension);
        if (fileExtension !== projectName.split(".").pop()) {
          toast.error(`Project name and file name extension must be same`, {
            position: "bottom-right",
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
            toastId: "field",
          });
          setFlag(!flag);
          const projectNameInput = document.getElementById("project-name");
          projectNameInput.addEventListener("click", (event) => {
            if (fileExtension !== projectName.split(".").pop()) {
              setFlag(flag);
            }
          });

          // } else if (fileExtension === projectName.split(".").pop()) {
          //   setFlag(flag);
        }
      });
    }
  };

  const config = {
    onUploadProgress: (progressEvent) => {
      if (progressEvent.loaded && progressEvent.total) {
        setProgress(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        );
      }
    },
  };

  const uploadSampleFile = async (e) => {
    const selectedFile = e.target.files[0];
    setSelectedFile(selectedFile);
    // console.log("##########################", uploadFile(selectedFile));
    let params =
      props?.role === "STUDIO_ADMIN"
        ? { key: projectName, studio_id: createdBy }
        : {
            key: projectName,
            //file: file,
          };
    //const response = { status: 200 };
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.S3BUCKET_PRESIGNED_URL
      }`,
      params,
      {},
      {}
    );

    if (response.status === 200) {
      console.log(response.data);
      setTempUrl(response.data.data.url);
    } else if (response.status === 409) {
      console.log("error", response.data.response.data.msg1);
      toast.error(`${response.data.response.data.msg1}`, {
        position: "bottom-right",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      //const fileInput = document.getElementById("file-input"); // replace "file-input" with the ID of your file input element
      //fileInput.files = []; // clear the value of the file input element
      //setFlag(flag); // toggle the value of "flag"
      const projectNameInput = document.getElementById("project-name");
      projectNameInput.addEventListener("input", (event) => {
        setFlag(flag);
      });
    }
    setFlag(!flag);
  };

  const handlePushToS3 = async () => {
    try {
      // const response = await api_call("PUT", tempUrl, file, {}, {});
      const response = await axios.put(tempUrl, selectedFile, config);
      if (response.status === 200) {
        console.log("SN", selectedFile.name);
        setProjectLink(selectedFile.name);
        console.log("pl", setProjectLink);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = async () => {
    if (projectName !== "") {
      const response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.PROJECTCONFIRM
        }`,
        {},
        {},
        {
          project_name: projectName,
          project_link: projectName,
          createdBy,
        }
      );
      console.log(projectName);
      if (response.status === 200) {
        props.handleClose();
        console.log("pp", projectName);
      }
    } else {
      toast.error(`Please add project name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };
  const handleBack = () => {
    props.handleClose();
  };
  // const uploadFile = (selectedFile) => {
  //   const params = {
  //     Bucket: S3_BUCKET,
  //     Key: selectedFile?.name,
  //     Body: selectedFile,
  //     ContentType: selectedFile?.type,
  //   };

  //   const partSize = 10 * 1024 * 1024;
  //   const queueSize = 1;
  //   return myBucket.upload(params, function (err, data) {
  //     console.log("params-----77777", data);

  //     if (err) {
  //       console.log("There was an error uploading your file: ", err);
  //       return false;
  //     }
  //     console.log("Successfully uploaded file.", data);
  //     setProjectLink(data);
  //     return true;
  //   });
  //   // return aBAC;
  // };

  return (
    <div id="myModal" className="cancelled-Modal">
      <div className="cancelled-Modal-content">
        <Stack className="project_header">
          <Typography variant="h6" className="upload-project">
            Upload Project
          </Typography>
        </Stack>
        <Grid container>
          <InputField
            type="text"
            id="project-name"
            placeholder="Project Name"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />
        </Grid>
        {flag ? (
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="browse_area upload-project-margin"
              onClick={() => handleButtonClick()}
              onChange={(e) => uploadSampleFile(e)}
            >
              <img
                src={Upload}
                className="upload_img"
                //   onClick={() => handleButtonClick()}
                //   onChange={(e) => uploadSampleFile(e)}
              ></img>
              <input
                id="file-upload"
                type="file"
                accept=".zip,.rar,.7z"
                name="fileUpload"
                style={{ display: "none" }}
              />
              <div
                for="file-upload"
                //   onChange={(e) => uploadSampleFile(e)}
                className=""
              >
                <Typography
                  variant="h6"
                  id="file-drag"
                  className="progress_report"
                  // onClick={() => handleButtonClick()}
                  // onChange={(e) => uploadSampleFile(e)}
                >
                  Browse project file
                </Typography>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Typography variant="h6" className="progress_report">
            *Please do not refresh the page or change the network while
            uploading the file*
          </Typography>
        )}
        <Grid className="progress_container">
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              borderRadius: "10px",
              height: "6px",
              backgroundColor: "#C6CCD6",
              "& .MuiLinearProgress-bar1": {
                backgroundColor: "#42C3FD ",
              },
            }}
          ></LinearProgress>
          <Typography variant="h6" className="progress_report">
            {progress === 100 ? `File uploaded` : `Uploading ${progress}%`}
          </Typography>
        </Grid>
        <Grid container spacing={0}>
          <div className="flexClass">
            <Button
              value="Back"
              role="primary"
              disabled={progress > 0}
              onClick={() => {
                handleBack();
              }}
              className="project_header"
            />
            <Button
              value="Continue"
              role="primary"
              onClick={() => {
                onSubmit();
              }}
              disabled={!continueButton && progress !== 100}
              className="project_header"
            />
          </div>
        </Grid>
      </div>
    </div>
  );
};

export default S3upload;
